module cr.events {
    eventModule.config(['crFormTemplateProvider', (crFormTemplateProvider:any) => {
        crFormTemplateProvider.setTemplateUrl('event', 'modules/event/views/formevent.html');
    }]);
}
